module.exports = __webpack_public_path__ + "img/FundoOCR.6cc7df8a.png";